import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import {getRecaptchaToken} from '../../../../utilities/recaptcha/recaptcha';
import {goToPage, reportAnalytics, setIsSubmit, setIsValid, setOtpPhone, setOtpTicketId, setOtpIdentity} from '../saleBlockSlice';
import OTPVerifyPhone from '../OTPVerifyPhone/OTPVerifyPhone';

const OtpVerifyPhonePage = (props) => {
  let saleType = props.saleType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'visibility_20', eventLabel: eventLabel});
        break;
      case 'app':
        props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'visibility_28', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'visibility_23', eventLabel: 'screen_13'});
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_16', eventLabel: eventLabel});
        break;
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'שליחת קוד אימות';
  let currentPageFunction = handleOtpVerifyPhonePageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';

  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      {saleType == 'internet' ? (
        <h1 className='sale-title-big'>מעולה, יש לכם תשתית סיבים מוכנה בבניין!</h1>
      ) : (
        <h1 className='sale-title-big'> מי איתנו על הקו? </h1>
      )}

      <h2 className='sale-title-small'> פרטי התחברות </h2>
    </div>
  );

  let currentPageView = <OTPVerifyPhone onValid={handleOTPVerifyPhoneValidate} onSubmit={props.isSubmit} isDisplayIdentity={true} />;

  function handleOtpVerifyPhonePageContinue() {
    props.setIsSubmit({isSubmit: true});
  }

  function handleOTPVerifyPhoneValidate(valid) {
    props.setIsSubmit({isSubmit: false});
    if (valid) {
      handleOtpVerifyPhonePageContinueAfterValid();
    }
    props.setIsSubmit({isSubmit: false});
  }

  async function handleOtpVerifyPhonePageContinueAfterValid() {
    const eventLabel = props.productsInfo.selectedProducts[0]?.name;

    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'click_29', eventLabel: eventLabel});
        break;
      case 'app':
        props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'click_39', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_45', eventLabel: 'button_12'});
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_21', eventLabel: eventLabel});
        break;
    }

    const step1Ticket = await createOtp();
    if (step1Ticket && step1Ticket != '') {
      props.setOtpTicketId({otpTicketId: step1Ticket});
      props.setOtpPhone({otpPhone: props._otpPhone});
      props.setOtpIdentity({identity: props._otpIdentity});
    }

    switch (saleType) {
      case 'tv':
        props.goToPage({page: 'otpVerifyCode', percent: 54});
        break;
      case 'app':
        props.goToPage({page: 'otpVerifyCode', percent: 42});
        break;
      case 'cellular':
        props.goToPage({page: 'otpVerifyCode', percent: 60});
        break;
      case 'internet':
        props.goToPage({page: 'otpVerifyCode', percent: 30});
        break;
    }
  }

  async function createOtp() {
    const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const result = await ProviderManager.getProviderData('createOtp', [props._otpPhone, false, captchaToken]);
      if (result.Body && result.Body.step1Ticket) {
        return result.Body.step1Ticket;
      }
    } catch (error) {
      console.info('createOtp', error);
      return null;
    } finally {
      props.hideAppLoader();
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    productsInfo: state.saleBlock.productsInfo,

    //other states
    _otpPhone: state.otpVerifyPhone.form.phone,
    _otpIdentity: state.otpVerifyPhone.form.id,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setOtpPhone,
  setOtpTicketId,
  setOtpIdentity,

  //loader
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyPhonePage);
